<!-- Original Template -->
<div
  *ngIf="!enableMachCoreProfileSelector"
  class="personalProfileSelectorScreen"
>
  <div class="profileSelectorProfileType">
    {{ pageData.title }}
  </div>
  <div
    (click)="onClick($event)"
    (keydown.enter)="onClick($event)"
    (keydown.space)="onClick($event)"
    [ngClass]="{ active: active }"
    class="personalProfileSelectorScreen__content--text"
    role="button"
    tabindex="0"
    data-acdl-action="header profile selector flyout:select personal profile"
    data-acdl-event-detail="header profile flyout select a profile cta click"
    data-acdl-page-section="header:profile selector flyout"
    [attr.data-acdl-name]="'personal profile'"
    [attr.aria-label]="
      this.active ? pageData.displayName + ' Selected' : pageData.displayName
    "
  >
    <div class="displayName">
      {{ pageData.displayName }}
    </div>
    <span [ngClass]="{ active: active }" class="personal-check-mark"></span>
  </div>
</div>

<!-- New MachCore Template -->
<div
  *ngIf="enableMachCoreProfileSelector"
  class="personalProfileSelectorMachCore"
>
  <div
    class="personalProfileSelectorMachCore__title font-semibold text-[13px] leading-4 text-[#0b1f66] mb-[16px]"
  >
    {{ pageData.title }}
  </div>
  <button
    type="button"
    (click)="onClick($event)"
    [ngClass]="{
      'bg-[#6c718a]': active,
      'bg-[#f5f7fa]': !active
    }"
    class="personalProfileSelectorMachCore__content flex items-center h-[50.16px] px-[16px] py-[12px] hover:cursor-pointer hover:bg-[#6c718a] hover-text-white hover-icon-inverse w-full text-left"
    data-acdl-action="header profile selector flyout:select personal profile"
    data-acdl-event-detail="header profile flyout select a profile cta click"
    data-acdl-page-section="header:profile selector flyout"
    [attr.data-acdl-name]="'personal profile'"
  >
    <div
      [tabIndex]="0"
      [attr.aria-label]="this.active ? pageData.displayName + ' Selected' : ''"
      role="button"
      [ngClass]="{
        'text-inverse': active,
        'text-[#0b1f66]': !active
      }"
      class="personalProfileSelectorMachCore__display-name text-caption-semibold leading-[27.5px] text-left"
    >
      {{ pageData.displayName }}
    </div>
    <span
      *ngIf="active"
      class="personalProfileSelectorMachCore__check-mark ml-auto self-center"
    >
      <svg
        class="bg-[#fff] rounded-[100%] p-[2px]"
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3725 0L4.5939 7.91196L1.35412 4.93899L0 6.51235L4.89104 11L12 1.26725L10.3725 0Z"
          fill="#0B1F66"
        />
      </svg>
    </span>
  </button>
</div>
